import { graphql } from "../generated";

export const AbortMultipartUpload = graphql(`
  mutation AbortMultipartUpload($input: AbortMultipartUploadInput!) {
    abortMultipartUpload(input: $input)
  }
`);

export const CompleteMultipartUpload = graphql(`
  mutation CompleteMultipartUpload($input: CompleteMultipartUploadInput!) {
    completeMultipartUpload(input: $input) {
      key
      fileName
      extension
      contentType
      size
      s3Key
      s3Path
      uploadedAt
      s3Bucket
      url
      preview(
        options: {
          accept: [VIDEO_MP4, AUDIO_MP3, PDF, IMAGE_WEBP, IMAGE_PNG, IMAGE_JPEG, IMAGE_GIF]
          quality: UNSCALED
        }
      ) {
        contentType
        url
      }
      thumbnail: preview(options: { accept: [IMAGE_WEBP], quality: SCALED_240P }) {
        contentType
        url
      }
      totalUnits
      unit
      previews(
        params: {
          options: {
            quality: UNSCALED
            accept: [IMAGE_PNG]
            unit: PAGE
            slices: { unitsPerSlice: 1 }
          }
        }
      ) {
        nodes {
          url
          width
          height
          currentIndex
        }
      }
    }
  }
`);

export const CreateMultipartUpload = graphql(`
  mutation CreateMultipartUpload($input: CreateMultipartUploadInput!) {
    createMultipartUpload(input: $input) {
      key
      s3Key
    }
  }
`);

export const MultipartUpload = graphql(`
  query MultipartUpload($fileKey: ID!) {
    multipartUpload(fileKey: $fileKey) {
      parts {
        partNumber
        size
        eTag
      }
    }
  }
`);

export const SignMultipartUploadPart = graphql(`
  query SignMultipartUploadPart($params: MultipartUploadURLParams!) {
    multipartUploadURL(params: $params) {
      partNumber
      presignedUrl
      expiresIn
    }
  }
`);
